export default __webpack_public_path__ + "static/sdg-8-6e7acc1cd8c00e2088f387fda957aac5.png";